const WAVY_FRAMES = {
  'wavy-shape-a': [
    [24, 0, 100, 35],
    [89, 100, 0, 72],
    [61, 0, 100, 83],
    [24, 0, 100, 35]
  ],
  'wavy-shape-b': [
    [0, 100, 0, 100],
    [100, 0, 100, 0],
    [50, 100, 0, 50],
    [0, 100, 0, 100]
  ],
  'wavy-shape-c': [
    [30, 90, 90, 30],
    [70, 10, 10, 70],
    [30, 90, 90, 30],
    [30, 90, 90, 30]
  ]
};

const WAVE_CACHE = new Map();

function lerp(a, b, t) {
  return a + (b - a) * t;
}

function formatPoint(value) {
  return Number(value.toFixed(3)).toString();
}

function frameToPath(frame) {
  const [m0, c1, c2, c3] = frame;
  return `M0,${formatPoint(m0)} C480,${formatPoint(c1)} 960,${formatPoint(c2)} 1440,${formatPoint(c3)} L1440,100 L0,100 Z`;
}

function getWaveTimeline(shapeKey) {
  const cached = WAVE_CACHE.get(shapeKey);
  if (cached) return cached;
  const frames = WAVY_FRAMES[shapeKey];
  if (!frames || frames.length < 2) return null;
  const timeline = { frames, segments: frames.length - 1 };
  WAVE_CACHE.set(shapeKey, timeline);
  return timeline;
}

function wrap01(value) {
  return value - Math.floor(value);
}

function sampleWavePath(timeline, progress) {
  if (!timeline || timeline.segments <= 0) return '';
  const wrapped = wrap01(progress);
  const scaled = wrapped * timeline.segments;
  let segmentIndex = Math.floor(scaled);
  if (segmentIndex >= timeline.segments) segmentIndex = timeline.segments - 1;
  const localT = scaled - segmentIndex;
  const from = timeline.frames[segmentIndex];
  const to = timeline.frames[segmentIndex + 1];
  const frame = [
    lerp(from[0], to[0], localT),
    lerp(from[1], to[1], localT),
    lerp(from[2], to[2], localT),
    lerp(from[3], to[3], localT)
  ];
  return frameToPath(frame);
}

function resolveWaveShape(path) {
  for (const key of Object.keys(WAVY_FRAMES)) {
    if (path.classList.contains(key)) return key;
  }
  return null;
}

export function initTerracesGrow(options = {}) {
  const sels = options.selector ?? '[data-ter-ani]';
  const sections = Array.from(document.querySelectorAll(sels))
    .map((sec) => {
      const terraces = sec.querySelector('.terraces');
      if (!terraces) return null;
      const waves = Array.from(terraces.querySelectorAll('.wavy-path'))
        .map((path) => {
          const shapeKey = resolveWaveShape(path);
          if (!shapeKey) return null;
          const timeline = getWaveTimeline(shapeKey);
          if (!timeline) return null;
          const speedRaw = parseFloat(path.getAttribute('data-wavy-speed'));
          const phaseRaw = parseFloat(path.getAttribute('data-wavy-phase'));
          const speed = Number.isFinite(speedRaw) ? speedRaw : 1;
          const phase = Number.isFinite(phaseRaw) ? phaseRaw : 0;
          return { path, timeline, speed, phase };
        })
        .filter(Boolean);
      return { sec, terraces, waves };
    })
    .filter(Boolean);

  if (!sections.length) return () => {};

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const onScroll = () => {
    const vh = window.innerHeight || 1;
    for (const item of sections) {
      const { sec, terraces, waves } = item;
      const rect = sec.getBoundingClientRect();
      let progress = (vh - rect.bottom) / vh;
      if (progress < 0) progress = 0;
      else if (progress > 1) progress = 1;

      if (prefersReduced) {
        terraces.style.removeProperty('--ter-scale');
        terraces.style.removeProperty('transform');
        for (const wave of waves) {
          wave.path.setAttribute('d', frameToPath(wave.timeline.frames[0]));
        }
        continue;
      }

      const maxScale = parseFloat(sec.getAttribute('data-ter-scale-max')) || 2;
      const scale = 1 + progress * (maxScale - 1);
      terraces.style.setProperty('--ter-scale', String(scale));

      for (const wave of waves) {
        const waveProgress = progress * wave.speed + wave.phase;
        const d = sampleWavePath(wave.timeline, waveProgress);
        if (d) wave.path.setAttribute('d', d);
      }
    }
  };

  const onResize = () => onScroll();

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);

  return () => {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onResize);
  };
}
